import { render, staticRenderFns } from "./ParaMedical.vue?vue&type=template&id=594d3f96&"
import script from "./ParaMedical.vue?vue&type=script&lang=js&"
export * from "./ParaMedical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports